import { curry } from 'lodash'
import {
  UPDATE_ASYNC_WAIT_FILTER,
  CREATE_ASYNC_LISTENER,
} from './constants'

const updateAsyncFilter = (count) => (action) => {
  return {
    type: UPDATE_ASYNC_WAIT_FILTER,
    action,
    count
  }
}

export const decrementAsyncFilter = updateAsyncFilter(-1)
export const incrementAsyncFilter = updateAsyncFilter(1)

/**
 * asyncReduxFilter
 *
 * Listens for action call and creates an action
 *
 * @param actionName
 * @param request
 * @returns thunk action
 */
export const asyncReduxFilter = curry((actionName, request) => (
  (...args) => {
    return dispatch => {
      let promise = new Promise( (resolve, reject) => {
        dispatch(incrementAsyncFilter(actionName))
        resolve()
      })

      return promise
        .then(() => dispatch(request(...args)))
        .then((data) => {
          dispatch(decrementAsyncFilter(actionName))
          return data
        })
        .catch(err => decrementAsyncFilter(actionName))
    }
  }
))

/**
 * asyncReduxPromiseFilter
 *
 * Wraps around async requests and listens for action calls
 *
 * @param actionName
 * @param request
 * @returns thunk action
 */
export const asyncReduxPromiseFilter = curry((actionName, request) => (
  (...args) => {
    return dispatch => {
      dispatch(incrementAsyncFilter(actionName))
      return request(...args)
        .then((data) => {
          dispatch(decrementAsyncFilter(actionName))
          return data
        })
        .catch(err => decrementAsyncFilter(actionName))
    }
  }
))

export const buildAsyncAction = curry((actionName, incrementActions, decrementActions) =>
  () => ({ type: CREATE_ASYNC_LISTENER, actionName, incrementActions, decrementActions })
)
